var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.01792 16.4159L17.5781 11.1419C17.7698 11.0244 18.0152 11.0357 18.1947 11.1744C19.008 11.8007 19.7346 12.4357 20.2194 12.9695C20.2194 12.9695 20.637 13.397 20.8177 13.6683C21.1096 14.0383 21.25 14.5221 21.25 14.9921C21.25 15.5197 21.0961 16.0184 20.7896 16.4172C20.72 16.4884 20.455 16.8022 20.2047 17.0585C18.7442 18.6536 14.9319 21.2887 12.9268 22.0875C12.6349 22.2162 11.8558 22.485 11.4516 22.5C11.0621 22.5 10.686 22.415 10.3245 22.2287C9.88004 21.9725 9.53201 21.575 9.33663 21.1037C9.21086 20.7762 9.0167 19.7936 9.0167 19.7649C8.89092 19.0636 8.79689 18.0785 8.75049 16.9285C8.74194 16.7222 8.84574 16.5222 9.01792 16.4159Z",
    fill: "#1D1D1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.59041 13.5754C9.21308 13.8092 8.73806 13.5104 8.75637 13.0616C8.80156 12.0091 8.87971 11.0815 8.97496 10.3915C8.98961 10.3765 9.18377 9.15269 9.40724 8.73892C9.79678 7.97013 10.5612 7.5001 11.383 7.5001H11.4514C11.9814 7.51385 13.1085 7.98388 13.1085 8.01263C13.6763 8.24889 14.4175 8.64891 15.2149 9.13018C15.574 9.34769 15.5825 9.88147 15.2235 10.1027L9.59041 13.5754Z",
    fill: "#1D1D1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.142e0cea42a7024220c7adc75f0ad87c.svg";
export { ForwardRef as ReactComponent };